import Input from '@returnmates/ui-core/src/components/Input'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

interface Props {
  isInitialCodeExist?: boolean
}

function HeaderSettings({ isInitialCodeExist }: Props) {
  const classes = useStyles({})

  return (
    <>
      {!isInitialCodeExist ? (
        <div className={classes.detailsRow}>
          <p className={classes.inputHead}>Code</p>
          <Field name="code">
            {({ input, meta }) => (
              <Input
                placeholder="abc"
                classes={{
                  textField: classes.input,
                }}
                onChange={input.onChange}
                value={input.value}
                fullWidth
                helperText={meta.error}
                error={meta.touched && meta.error}
              />
            )}
          </Field>
        </div>
      ) : null}
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Name</p>
        <Field name="name">
          {({ input, meta }) => (
            <Input
              placeholder="Partner name"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Header</p>
        <Field name="header">
          {({ input, meta }) => (
            <Input
              placeholder="Online returns without leaving your home"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Sub header</p>
        <Field name="subHeader">
          {({ input, meta }) => (
            <Input
              placeholder="The first one is on us!"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>First bullet header</p>
        <Field name="bulletHeader1">
          {({ input, meta }) => (
            <Input
              placeholder="Schedule your pickup"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>First bullet subheader</p>
        <Field name="bulletSubHeader1">
          {({ input, meta }) => (
            <Input
              placeholder="Choose your preferred date and pickup method"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Second bullet header</p>
        <Field name="bulletHeader2">
          {({ input, meta }) => (
            <Input
              placeholder="Leave on doorstep"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Second bullet subheader</p>
        <Field name="bulletSubHeader2">
          {({ input, meta }) => (
            <Input
              placeholder="Receive a pickup ETA morning of and a 15 minute heads-up via text"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Third bullet header</p>
        <Field name="bulletHeader3">
          {({ input, meta }) => (
            <Input
              placeholder="We take care of the rest"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Third bullet subheader</p>
        <Field name="bulletSubHeader3">
          {({ input, meta }) => (
            <Input
              placeholder="We pick up your returns and ship them back for you"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Button text</p>
        <Field name="button">
          {({ input, meta }) => (
            <Input
              placeholder="Schedule Now"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
      <div className={classes.detailsRow}>
        <p className={classes.inputHead}>Submit Button</p>
        <Field name="submitButton">
          {({ input, meta }) => (
            <Input
              placeholder="Schedule"
              classes={{
                textField: classes.input,
              }}
              onChange={input.onChange}
              value={input.value}
              fullWidth
              helperText={meta.error}
              error={meta.touched && meta.error}
            />
          )}
        </Field>
      </div>
    </>
  )
}

export default memo(HeaderSettings)
